module.exports = __webpack_public_path__ + "static/media/testimony2.dfe373e5.jpg";